import React from "react";
import { List, Datagrid, TextField, EditButton } from "admin-on-rest";
import find from "lodash.find";
import IconTitle from "../components/icon_title";
import Pagination from "../components/pagination";
import { PaymentFilter, PaymentActions, typePayment } from "./defaultValues";

const ActiveField = ({ record = {} }) => {
  const text = record.active ? "Active" : "Inactive";
  return <span>{text}</span>;
};
ActiveField.defaultProps = { label: "Active" };

const TypeField = ({ record = {} }) => {
  let text = find(typePayment, function(o) {
    return o.id === record.type;
  });
  return <span>{text.name}</span>;
};
TypeField.defaultProps = { label: "Type" };

export const PaymentList = props => (
  <List
    {...props}
    actions={<PaymentActions />}
    title={
      <IconTitle icon="payments" title={"resources.payments.titleHeader"} />
    }
    sort={{ field: "created_at", order: "DESC" }}
    filters={<PaymentFilter />}
    perPage={10}
    pagination={<Pagination />}
  >
    <Datagrid bodyOptions={{ showRowHover: true }}>
      <TextField label="resources.payments.field.bankName" source="name" />
      <TypeField label="resources.payments.field.type" source="type" />
      <ActiveField label="resources.payments.field.active" source="active" />
      <EditButton label="" style={{ textAlign: "right" }} />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/payment/List.js